
// ROUTES
require('modules/pages/routes/pages');

// CONTROLLERS
require('modules/pages/controllers/pages');

angular.module('unica_pages', [

	// ROUTES
	'unica_pages.pages_routes',

	// CONTROLLERS
	'unica_pages.pages_controllers',

]);